export enum ScalesField {
    ID = 'id',
    NAME = 'name',
    STORAGE = 'storage',
    URI = 'uri',
    TOKEN = 'token',
}
